import React, { useEffect, useState } from "react";
import "./AnimatedBackground.css";

const AnimatedBackground = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="animated-background">
      <div
        className="gradient-orb orb-1"
        style={{
          transform: `translate(${scrollY * 0.15}px, ${
            scrollY * 0.2
          }px) rotate(${scrollY * 0.05}deg)`,
        }}
      />
      <div
        className="gradient-orb orb-2"
        style={{
          transform: `translate(${-scrollY * 0.2}px, ${
            scrollY * 0.25
          }px) rotate(${-scrollY * 0.08}deg)`,
        }}
      />
      <div
        className="gradient-orb orb-3"
        style={{
          transform: `translate(${scrollY * 0.1}px, ${
            -scrollY * 0.15
          }px) rotate(${scrollY * 0.03}deg)`,
        }}
      />
      <div className="gradient-mesh" />
    </div>
  );
};

export default AnimatedBackground;
